import { render, staticRenderFns } from "./NotificationTypeAutocomplete.vue?vue&type=template&id=5a659fc2"
import script from "./NotificationTypeAutocomplete.vue?vue&type=script&lang=ts"
export * from "./NotificationTypeAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports